import FileUploadIcon from './component'

export default FileUploadIcon
